// import Throttle from "../util/Throttle";

export default function() {
  const body = document.querySelector("body");
  const mainNav = document.querySelector(".js-mainNav");
  const megaMenu = document.querySelector(".js-megaMenu");

  const hamburger = document.querySelector(".js-hamburger");
  const openMegaMenu = document.querySelector(".js-openMegaMenu");
  const closeMainNav = document.querySelector(".js-closeMainNav");
  const closeMegaMenu = document.querySelector(".js-closeMegaMenu");

  function preventDefault(e) {
    e.preventDefault();
  }

  function disableScroll() {
    document.body.addEventListener("touchmove", preventDefault, {
      passive: false,
    });
  }
  function enableScroll() {
    document.body.removeEventListener("touchmove", preventDefault, {
      passive: false,
    });
  }

  // event listener for hamburger
  hamburger.addEventListener("click", e => {
    hamburger.classList.toggle("is-active");
    mainNav.classList.toggle("is-open");
    body.classList.toggle("noScroll");
    // block touch events, this prevents touch scroll on devices
    // https://stackoverflow.com/questions/28790889/css-how-to-prevent-scrolling-on-ios-safari
    // and https://stackoverflow.com/a/49853392
    disableScroll();
    preventDefault(e);
  });

  // event listener for close button
  closeMainNav.addEventListener("click", e => {
    hamburger.classList.toggle("is-active");
    mainNav.classList.toggle("is-open");
    body.classList.toggle("noScroll");
    // document.ontouchmove = function(e) {
    //   return true;
    // };
    enableScroll();
    preventDefault(e);
  });

  // init megamenu if megamenu exists
  if (openMegaMenu != null) {
    // event listener for the link that opens megamenu
    openMegaMenu.addEventListener("click", e => {
      // check if megamenu has display: block first (which implies that it's on larger screens)
      const style = window.getComputedStyle(megaMenu);
      const displaySetTo = style.display;
      if (displaySetTo === "none") {
        // do nothing, proceed with current behaviour
      } else {
        megaMenu.classList.toggle("is-open");
        e.preventDefault();
      }
    });

    // event listener for closing megamenu
    closeMegaMenu.addEventListener("click", e => {
      e.preventDefault();
      megaMenu.classList.toggle("is-open");
    });
  }
  // handle scroll
  let lastKnownScrollPos = 0;
  let ticking = false;

  function handleNavScroll(scrollPos) {
    // do something with the scroll position
    // console.log(scrollPos);
    if (scrollPos > 150) {
      // add class if dont have
      if (!body.classList.contains("has-scrolled")) {
        body.classList.add("has-scrolled");
      }
    } else {
      // remove class
      body.classList.remove("has-scrolled");
    }
  }

  // scroll listener
  window.addEventListener("scroll", e => {
    lastKnownScrollPos = window.pageYOffset;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleNavScroll(lastKnownScrollPos);
        ticking = false;
      });
      ticking = true;
    }
  });

  // another way of detecting scrolltop
  // const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
}



// WEBPACK FOOTER //
// ./assets/scripts/modules/navigation.js